"use client";
import React, { useCallback } from "react";
import SelectLenses from "./SelectLenses";
import FavoriteBtn from "./FavoriteBtn";

import PackageEsSelectBtn from "../ProductPackageEs/PackageEsSelectBtn";
import emitter from "../../../lib/emitter";
import { EVT_PACKAGE_ERROR_TIP } from "@/lib/eventbus";
import classnames from "classnames";
import stl from "./buttonline.module.scss";
import { FmButton } from "@/ui-component";
import CompTryOn from "@/src/components/CompTryOn";
import { tryOn } from "@/store";
import {
    useCommonContext,
    useProductDetailsContext,
    useProductPackageContext,
} from "@/src/provider";
import ImageTryOn from "@/src/components/TryOn/ImageTryOn";
import { useTranslation } from "@/src/i18n/client";

interface Props {
    pageId: number | null;
}

const ButtonLine: React.FC<Props> = (props) => {
    const { site } = useCommonContext();
    const { t } = useTranslation("common");

    const [productImg, tryOnOn, openTryOn, closeTryOn, clickButtonToOpenTryOn] =
        tryOn.useTryonStore((state) => [
            state.productImg,
            state.openTryOnComp,
            state.openTryOn,
            state.closeTryOn,
            state.clickButtonToOpenTryOn,
        ]);
    const [packData, packDataIndex, isShowPackBtn] = useProductPackageContext(
        (state) => [state.packData, state.packDataIndex, state.isShowPackBtn],
    );

    const [activeObj, productDetail] = useProductDetailsContext((state) => [
        state.activeObj,
        state.productDetail,
    ]);

    const showErrorTip = () => {
        let package_ele = document.getElementById("package-container");
        let offsetTop: any = package_ele ? package_ele.offsetTop : 0;
        offsetTop && window.scrollTo(0, offsetTop - 88);
        emitter.emit(`${EVT_PACKAGE_ERROR_TIP}_`);
    };

    const handleTryOn = useCallback(() => {
        clickButtonToOpenTryOn(activeObj.id!, productDetail);
    }, [activeObj.id, clickButtonToOpenTryOn, productDetail]);

    return (
        <>
            <div className={stl["product-bottom-container"]}>
                <div
                    className={classnames(
                        "default_layout",
                        stl["flex-jusctify-product-try-on"],
                    )}
                >
                    {/* 产品或色号下架则隐藏tryOn和收藏 */}
                    {!(
                        productDetail.p_under_market ||
                        activeObj.colorUnderMarket
                    ) && (
                        <>
                            <FmButton
                                size="large"
                                variant="outlined"
                                onClick={(e) => handleTryOn()}
                                className={stl["try-on-btn"]}
                            >
                                {t("common:TRYON")}
                            </FmButton>
                            <FavoriteBtn
                                productsid={productDetail.products_id}
                            />
                        </>
                    )}
                </div>
                {site === "es" && isShowPackBtn && (
                    <PackageEsSelectBtn
                        isShowPackBtn={isShowPackBtn}
                        showErrorTip={showErrorTip}
                    />
                )}
                {(!isShowPackBtn || site !== "es") && (
                    <SelectLenses
                        style={ {
                            width: "100%",
                            fontSize: "0.27rem",
                            fontWeight: "bold",
                            border: "none",
                            borderRadius: "5px",
                            fontFamily: "var(--font-montserrat-bold)",
                        }}
                        title={
                            packDataIndex > 0 && site === "es"
                                ? "Elegir sus cristales"
                                : undefined
                        }
                        pageId={props.pageId}
                    />
                )}
            </div>

            {/*试戴*/}
            {tryOnOn && <ImageTryOn />}
            <CompTryOn onClose={closeTryOn} />
        </>
    );
};

export default ButtonLine;
